var map = {
	"./1994-95.pdf": 86769,
	"./1995-96.pdf": 90213,
	"./1996-97.pdf": 42017,
	"./1997-98.pdf": 40173,
	"./1998-99.pdf": 99185,
	"./1999-00.pdf": 27016,
	"./2000-01.pdf": 26371,
	"./2001-02.pdf": 74523,
	"./2002-03.pdf": 68507,
	"./2003-04.pdf": 92363,
	"./2004-05.pdf": 60171,
	"./2005-06.pdf": 16931,
	"./2006-07.pdf": 84227,
	"./2007-08.pdf": 25171,
	"./2008-09.pdf": 34451,
	"./2009-10.pdf": 29018,
	"./2010-11.pdf": 689,
	"./2011-12.pdf": 72141,
	"./2012-13.pdf": 20097,
	"./2013-14.pdf": 19925,
	"./2014-15.pdf": 59201,
	"./2015-16.pdf": 93445,
	"./2016-17.pdf": 57393,
	"./2017-18.pdf": 18157,
	"./2018-19.pdf": 80049,
	"./2019-20.pdf": 34886,
	"./2020-21.pdf": 57391,
	"./2021-22.pdf": 47743,
	"./2022-23.pdf": 6111,
	"./2023-2024.pdf": 96845,
	"./2024-25.pdf": 62687,
	"./2025-26.pdf": 12239,
	"./2026-27.pdf": 73551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18140;